export default __webpack_public_path__ + "static/media/im-title-cn.36d9365d.webp";